exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin_inner .vue-simple-suggest.designed .suggestions[data-v-09bb8071]{top:-moz-calc(100% - 1px);top:calc(100% - 1px);max-width:100%;width:100%;-webkit-transform:translateX(0);-moz-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}.no-header[data-v-09bb8071]{display:none}.login_inner[data-v-09bb8071]{padding-bottom:8rem}.right.prod_details_tab.login_tab a[data-v-09bb8071]{color:#213519}.right.prod_details_tab.login_tab.highlight a[data-v-09bb8071]{color:#1e824c;border-color:#1e824c}", ""]);

// exports
